import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import { Checkbox as AriaCheckbox, CheckboxProps } from "react-aria-components";

import { getTextStyle } from "@certn/cascadia-react/foundations/typography/styles";

import { _CheckboxAsset } from "./_CheckboxAsset";
import { sharedStyles, useCardInputStyles } from "../../styles";
import { LabelAlign } from "../../../types";
interface Props extends CheckboxProps {
  isCard?: boolean;
  noBorder?: boolean;
  strong?: boolean;
  labelAlign?: LabelAlign;
}

export function _Checkbox(props: Props) {
  const cardStyles = useCardInputStyles();
  const { noBorder, isCard, labelAlign = "vertical", ...checkboxProps } = props;
  const className = css(
    styles.checkbox,
    isCard && cardStyles,
    isCard && sharedStyles.basicCard,
    noBorder && sharedStyles.noBorder
  );

  return (
    <AriaCheckbox
      {...mergeProps(checkboxProps, { className })}
      data-label-orientation={labelAlign}
    >
      {(renderProps) => {
        return (
          <>
            <_CheckboxAsset
              {...renderProps}
              isFocused={isCard ? false : renderProps.isFocused}
              isFocusVisible={isCard ? false : renderProps.isFocusVisible}
            />
            <div
              className={css(styles.text)}
              data-label-orientation={labelAlign}
            >
              {typeof props.children === "function"
                ? props.children(renderProps)
                : props.children}
            </div>
          </>
        );
      }}
    </AriaCheckbox>
  );
}

const styles = {
  checkbox: css(
    {
      cursor: "pointer",
      display: "flex",
      flexDirection: "row",
      gap: "var(--space-2)",
      paddingBottom: "var(--space-1)",
      paddingTop: "var(--space-1)",
      "&[data-label-orientation='horizontal']": {
        flexDirection: "row-reverse",
        justifyContent: "flex-end",
      },
    },
    getTextStyle("form/body-secondary")
  ),
  text: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-1)",
    "&[data-label-orientation='horizontal']": {
      width: 160,
      paddingInlineEnd: "var(--space-2)",
    },
  }),
};
